module.exports = __webpack_public_path__ + "img/square_header_1new.d6ad04da.png";